import { gql } from "@apollo/client";

export const ADMIN_SETTLES_BY_REQUEST_DATE = gql`
  query AdminSettlesByRequestDate($requestDate: String!, $state: String) {
    adminSettlesByRequestDate(requestDate: $requestDate, state: $state) {
      settleId
      sellerId
      storeId
      storeTitle
      requestDate
      settleWay
      settlePrice
      state
    }
  }
`;

export const ADMIN_BULK_UPDATE_SETTLE_STATE = gql`
  mutation AdminBulkUpdateSettleState(
    $settleIds: [Int!]!
    $nextState: String!
  ) {
    adminBulkUpdateSettleState(settleIds: $settleIds, nextState: $nextState) {
      ok
      error
    }
  }
`;

export const ADMIN_REQUEST_SETTLE = gql`
  mutation AdminRequestSettle($sellerId: Int!, $settleWay: String!) {
    adminRequestSettle(sellerId: $sellerId, settleWay: $settleWay) {
      ok
      error
      settleId
    }
  }
`;

export const ADMIN_CALCULATE_PENDING_SETTLEMENT = gql`
  query AdminCalculatePendingSettlement($sellerId: Int!) {
    adminCalculatePendingSettlement(sellerId: $sellerId) {
      totalPrice
      settlePrice
      settlementStartDate
      settlementEndDate
      nextPayoutDate
      hasRequiredSettlementInfo
      orderCount
    }
  }
`;

// 포맷터 함수
export const formatKRW = (v: number) => v.toLocaleString("ko-KR");

